import { useEffect } from 'react'
import { Users, CreditCard, TrendingUp, CheckCircle, Loader2 } from 'lucide-react'
import { useAdmin } from '../../hooks/use-admin'
import { useI18n } from '../../i18n'

export function DashboardSection() {
  const { dashboard, loading, fetchDashboard } = useAdmin()
  const { t } = useI18n()

  useEffect(() => {
    fetchDashboard()
  }, [fetchDashboard])

  if (loading && !dashboard) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-6 w-6 animate-spin text-orange-500" />
      </div>
    )
  }

  if (!dashboard) {
    return (
      <div className="text-center py-20 text-sm text-gray-400">
        {t('暂无数据', 'No data')}
      </div>
    )
  }

  const stats = [
    { label: t('用户总数', 'Total Users'), value: dashboard.totalUsers, icon: Users, color: 'text-blue-500' },
    { label: t('订单总数', 'Total Orders'), value: dashboard.totalOrders, icon: CreditCard, color: 'text-violet-500' },
    { label: t('本月营收', 'Revenue (Month)'), value: `¥${dashboard.revenueThisMonth?.toLocaleString() ?? 0}`, icon: TrendingUp, color: 'text-emerald-500' },
    { label: t('活跃订阅', 'Active Subs'), value: dashboard.activeSubscriptions, icon: CheckCircle, color: 'text-orange-500' },
  ]

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {stats.map((stat) => {
          const Icon = stat.icon
          return (
            <div key={stat.label} className="p-4 rounded-2xl bg-white border border-black/[0.04]">
              <div className="flex items-center gap-2 mb-2">
                <Icon className={`h-4 w-4 ${stat.color}`} />
                <span className="text-[11px] text-gray-400">{stat.label}</span>
              </div>
              <div className="text-xl font-semibold text-[#1a1a1a]">{stat.value}</div>
            </div>
          )
        })}
      </div>

      {dashboard.pendingOrders > 0 && (
        <div className="p-3 rounded-xl bg-amber-50 border border-amber-100 text-[13px] text-amber-600">
          {t(`${dashboard.pendingOrders} 笔待支付订单`, `${dashboard.pendingOrders} pending orders`)}
        </div>
      )}
    </div>
  )
}
